<!-- Translated: skip -->
<template>
  <div>
    <div class="banner">
      <OnSiteFooter style="z-index:1000000;" v-if="$store.state.isOnSite" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import OnSiteFooter from '@/components/components/OnSiteFooter';

export default {
  components: {
    OnSiteFooter,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'guidedPasses',
    ]),
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
    ]),
    open() {
      this.doTheOpening();
    },
    doTheOpening() {
      this.openModal(['SkiPassPickDate']);
    },
  },
  mounted() {
    this.open();
  },
};
</script>

<style lang="stylus">
body
  background-color white
</style>

<style scoped lang="stylus">
@import '~@/global.styl'

.banner
  height 100vh
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/toppbild-utrustning.jpg)
  background-position center
  position relative
  padding 0

</style>



// WEBPACK FOOTER //
// SkiPassOnSitePage.vue?3c35f130